import React     from 'react';
import PropTypes from 'prop-types';
import Flux      from '../../flux/Flux';

class TopFilter extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showLeft:   false,
            showRight:  false,
            showSticky: false,
        };

        this.wrapperRef          = null;
        this.topFilterWrapperRef = null;
        this.lastScrollPos       = 0;

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.onScroll      = this.onScroll.bind(this);
        this.onScrollTags  = this.onScrollTags.bind(this);
        this.scrollRight   = this.scrollRight.bind(this);
        this.scrollLeft    = this.scrollLeft.bind(this);
    }

    componentDidMount() {
        this.props.isSticky && Flux.Browser.addWindowScrollListener(this.onScroll);
    }

    componentWillUnmount() {
        this.props.isSticky && Flux.Browser.removeWindowScrollListener(this.onScroll);
    }

    onScroll() {
        const scrollPos           = document.documentElement.scrollTop;
        const useFixedSidebar     = !this.props.isMobile;
        const topFilterWrapperRef = this.props.topFilterCompRef.topFilterBarRef.topFilterWrapperRef;
        const compRef             = this.props.compRef;
        const filterContentRef    = compRef.filterRef.contentRef;
        const mainNav             = document.getElementById('main-navigation');
        const mainNavHeight       = mainNav ? mainNav.getBoundingClientRect().height : 0;
        const scrollFilter        = (window.scrollY - (window.scrollY + topFilterWrapperRef.getBoundingClientRect().bottom)) + (this.props.isMobile ? topFilterWrapperRef.getBoundingClientRect().height : mainNavHeight) + topFilterWrapperRef.getBoundingClientRect().height - 2;
        const isBottomPos         = compRef.gridCompRef && compRef.gridCompRef.gridRef && (window.innerHeight > compRef.gridCompRef.gridRef.getBoundingClientRect().bottom);

        //scroll up
        if ((scrollPos < this.lastScrollPos)) {
            if (useFixedSidebar) {
                filterContentRef.classList.add('content__filter-content--fixed');
                if (scrollFilter > 0) {
                    if (!isBottomPos) {
                        filterContentRef.style.top    = scrollFilter + "px";
                        filterContentRef.style.bottom = "auto";
                    }
                } else {
                    filterContentRef.classList.remove('content__filter-content--fixed');
                }
            }

            if (scrollFilter < 0) {
                this.setState({showSticky: false});
            } else {
                this.setState({showSticky: true});
            }

            // scroll Down
        } else if ((scrollPos > ((topFilterWrapperRef.getBoundingClientRect().top - topFilterWrapperRef.getBoundingClientRect().height) + window.scrollY))) {
            if (useFixedSidebar) {
                if (!isBottomPos) {
                    filterContentRef.style.top    = scrollFilter + "px";
                    filterContentRef.style.bottom = "auto";
                }
                filterContentRef.classList.add('content__filter-content--fixed');
                this.setState({showSticky: true});
            } else {
                this.setState({showSticky: false});
            }
        } else {
            useFixedSidebar && filterContentRef.classList.remove('content__filter-content--fixed');
            this.setState({showSticky: false});
        }
        this.lastScrollPos = scrollPos;
    }

    onScrollTags() {
        const elem  = this.wrapperRef;
        const state = {...this.state};

        if (elem.scrollLeft > 1) {
            state.showLeft = true;
        } else {
            state.showLeft = false;
        }
        if ((elem.scrollLeft + elem.getBoundingClientRect().width) < (elem.scrollWidth - 1)) {
            state.showRight = true;
        } else {
            state.showRight = false;
        }

        this.setState({...state});
    }

    setWrapperRef(ref) {
        if (ref) {
            this.wrapperRef = ref;
            const state     = {...this.state};

            if ((ref.scrollLeft + ref.getBoundingClientRect().width) < (ref.scrollWidth - 1)) {
                state.showRight = true;
            } else {
                state.showRight = false;
            }

            this.setState({...state});
        }
    }

    scrollLeft() {
        this.wrapperRef.scrollTo({
            left:     this.wrapperRef.scrollLeft - 100,
            behavior: 'smooth',
        });
    }

    scrollRight() {
        this.wrapperRef.scrollTo({
            left:     this.wrapperRef.scrollLeft + 100,
            behavior: 'smooth',
        });
    }

    render() {
        const style = {};

        if (this.props.isSticky && this.props.topFilterCompRef.topFilterBarRef && this.props.topFilterCompRef.topFilterBarRef.topFilterWrapperRef) {
            style['width'] = this.props.topFilterCompRef.topFilterBarRef.topFilterWrapperRef.getBoundingClientRect().width + 'px';
        }

        return <div className={'filter__top-tags' + (this.props.isSticky ? ' filter__top-tags--fixed' : '') + (this.props.isSticky && this.state.showSticky ? ' filter__top-tags--fixed-show' : '')}
                    ref={ref => this.topFilterWrapperRef = ref}
                    style={style}>
            {this.props.filterButton}
            {!this.props.isMobile && this.state.showLeft &&
                    <i className='icon -icon-single-arrow-left-line filter__top-tags__arrow' onClick={this.scrollLeft}></i>}
            <div className={'filter__top-tags__list-container' + (this.state.showLeft ? ' filter__top-tags__list-container--shadow-left' : '') + (this.state.showRight ? ' filter__top-tags__list-container--shadow-right' : '')}>
                <div className='filter__top-tags__list-wrapper' onScroll={this.onScrollTags} ref={this.setWrapperRef}>
                    {this.props.tagsList}
                </div>
            </div>
            {!this.props.isMobile && this.state.showRight &&
                    <i className='icon -icon-single-arrow-right-line filter__top-tags__arrow' onClick={this.scrollRight}></i>}
        </div>;
    }
}

TopFilter.propTypes = {
    tagsList:               PropTypes.node.isRequired,
    isMobile:               PropTypes.bool,
    filterButton:           PropTypes.node.isRequired,
    isSticky:               PropTypes.bool,
    setTopFilterWrapperRef: PropTypes.func,
    topFilterCompRef:       PropTypes.object,
    compRef:                PropTypes.object,

};

export default TopFilter;
